import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { PersonaInfo } from '@se-po/shared-data-access-models'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form"
    (ngSubmit)="submit()" novalidate>

    <h3>Child Profile Information</h3>
    <se-po-persona-info
      [labels]="{name: 'Child\\'s Full Name'}"
      formControlName="childInfo"
      [requiredFields]="['name', 'gender', 'dateOfBirth']"
      [optionalFields]="['gradYear']"
    ></se-po-persona-info>

    <h3>Account Owner Information</h3>
    <se-po-persona-info
      [labels]="{name: 'Your Full Name', dateOfBirth: 'Your Birthdate'}"
      formControlName="selfInfo"
      [requiredFields]="['name', 'dateOfBirth']"
      [optionalFields]="['gender']"
      [accountAgeRequired]="true"
    ></se-po-persona-info>

    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="submit"
        [seFeDataFullWidth]="true">Save Profiles</se-fe-button>
    </div>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { PersonaInfo } from '@se-po/shared-data-access-models'

@Component({
  selector: 'example-persona-info',
  templateUrl: 'example-persona-info.html',
})
export class MyExampleComponent implements OnInit {
  public ready = false
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) {}

  public ngOnInit(): void {
    const selfInfo: PersonaInfo = {
      name: {
        first: 'Jiminy',
        last: 'Cricket',
        preferred: 'Jim',
        suffix: 'Jr.',
      },
      gender: 'male',
      dateOfBirth: '1940-02-07',
      gradYear: '2005',
    } as PersonaInfo

    this.form = this.fb.group({
      childInfo: [],
      selfInfo: [selfInfo],
    })
    this.ready = true
  }

  public submit(): void {
    console.log('submit', this.form.value)
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-info-example',
  template,
  styleUrls: ['./persona-info-docs.component.scss'],
  standalone: false,
})
export class PersonaInfoExampleComponent extends SeFeDocsExampleComponent implements OnInit, OnDestroy {
  public files = [
    { src: exampleHtml, name: 'example.html', lang: 'html' },
    { src: exampleTypescript, name: 'example.ts', lang: 'typescript' },
  ]
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {
    super()
  }
  public ngOnInit(): void {
    const selfInfo: PersonaInfo = {
      name: {
        first: 'Jiminy',
        last: 'Cricket',
        preferred: 'Jim',
        suffix: 'Jr.',
      },
      gender: 'male',
      dateOfBirth: '1940-02-07',
      gradYear: '2005',
    } as PersonaInfo

    this.form = this.fb.group({
      childInfo: [],
      selfInfo: [selfInfo],
    })
  }

  public ngOnDestroy(): void {
    this.seFeToastService.events.next(undefined)
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed', this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
